// extracted by mini-css-extract-plugin
export default {"wrap":"Idle_wrap__lXsln","brand":"Idle_brand__lK7da","prefix":"Idle_prefix__MQGXa","title":"Idle_title__AHxR9"};